import React, { useState } from 'react'
import '../businessAnalysis/businessAnalysis.css'
import { Link } from 'react-router-dom'
const BusinessManagement = () => {
    const [box, setBox] = useState([

        {
            title: 'Add Booking',
            quatity: '',
            url: 'https://img.icons8.com/office/256/booking.png',
            // href: "/dashboard/add_new_booking"
        },
        {
            title: 'All Bookings',
            quatity: '',
            url: 'https://img.icons8.com/office/256/booking.png',
            // href: "/dashboard/booking-list"
        },
        {
            title: 'Update Your Calendar',
            quatity: '',
            url: 'https://cdn-icons-png.flaticon.com/512/8286/8286738.png',
            href: "/dashboard/calendar"
        },
        {
            title: 'Calendar List',
            quatity: '',
            url: 'https://cdn-icons-png.flaticon.com/512/8286/8286738.png',
            href: "/dashboard/calendar-list"
        },
        {
            title: 'Pending Queries ',
            quatity: '56',
            url: 'https://cdn.iconscout.com/icon/premium/png-256-thumb/impression-2634419-2187376.png'
        },
        {
            title: 'Total Queries',
            quatity: '433',
            url: 'https://cdn.iconscout.com/icon/premium/png-256-thumb/response-time-2682020-2232039.png'
        },
        {
            title: 'Promote Business',
            quatity: '',
            url: 'https://cdn-icons-png.flaticon.com/512/5702/5702664.png'
        },
    ])
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="card">
                    <div className="card-body">
                        <div className="d-md-flex align-items-center">
                            <h4 className="card-title">Business Management</h4>

                        </div>
                        <div className="col-lg-12">
                            <div className="row">
                                {
                                    box.map((cur, index) => {
                                        return (
                                            <div className="col-md-3 col-6" key={index}>
                                                <div className=" p-10  text-center total_card shadow-sm ">
                                                    <div className='data d-flex justify-content-around'>
                                                        <img src={cur.url} className='dash_icon'
                                                        />
                                                        <h4 className="">{cur.quatity}</h4>
                                                    </div>
                                                    <Link to={cur.href}><p className="p-2" style={{color:"#000"}}>{cur.title}</p> </Link>
                                                </div>
                                            </div>

                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}
export default BusinessManagement